"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledInput = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _identifier = require("../../util/identifier");
var _FormField = require("../FormField/FormField.context");
var _LabeledInput = require("./LabeledInput.styles");
var _excluded = ["disabled", "error", "fluid", "input", "label", "readOnly", "required", "size", "children"];
/**
 * @related ['Input', 'Label']
 * @since 8.23.0
 */
var LabeledInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var disabled = props.disabled,
    error = props.error,
    fluid = props.fluid,
    input = props.input,
    label = props.label,
    readOnly = props.readOnly,
    required = props.required,
    size = props.size,
    children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var inputClone = /*#__PURE__*/(0, _react.cloneElement)(input, Object.assign({
    fluid: fluid,
    size: 'lg',
    placeholder: input.props && input.props.placeholder ? input.props.placeholder : ' '
  }, rest));
  var context = Object.assign({}, (0, _react.useContext)(_FormField.FormFieldContext), {
    // Create a default id to be used with the input and labels
    controlId: (0, _react.useRef)((0, _identifier.identifier)()).current
  });
  if (typeof disabled !== 'undefined') {
    context.disabled = disabled;
  }
  if (typeof error !== 'undefined') {
    context.error = error;
  }
  if (typeof readOnly !== 'undefined') {
    context.readOnly = readOnly;
  }
  if (typeof required !== 'undefined') {
    context.required = required;
  }

  // Note: selection control components should come first in the DOM tree so that
  // labels can trigger off :hover/:focus states.
  return /*#__PURE__*/_react.default.createElement(_LabeledInput.StyledLabeledInput, {
    ref: forwardedRef
  }, /*#__PURE__*/_react.default.createElement(_FormField.FormFieldContext.Provider, {
    value: context
  }, inputClone, label));
});
exports.LabeledInput = LabeledInput;
LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Displays the input in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * Displays the input in an error state. Can also be inherited from a FormField parent.
   */
  error: _propTypes.default.bool,
  /**
   * Inputs are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the inputs's width is set to `auto`.
   */
  fluid: _propTypes.default.bool,
  /**
   * A `Input` component.
   */
  input: _propTypes.default.node.isRequired,
  /**
   * A `Label` component.
   */
  label: _propTypes.default.node.isRequired,
  /**
   * Displays the input in a read-only state. Can also be inherited from a FormField parent.
   *
   * @since 8.27.0
   */
  readOnly: _propTypes.default.bool,
  /**
   * Indicates the input is required. Can also be inherited from a FormField parent.
   */
  required: _propTypes.default.bool
} : {};
LabeledInput.defaultProps = {
  fluid: true
};